import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Box, Typography, FormControlLabel, FormGroup } from "@mui/material";
import PrimaryCheckbox from "../../../Inputs/PrimaryCheckBox/PrimaryCheckBox";
import PrimaryButton from "../../../Buttons/PrimaryButton/PrimaryButton";
import SecondaryButton from "../../../Buttons/SecondaryButton/SecondaryButton";
import StyledPopover from "../../../StyledPopover/StyledPopover";
import FilterButton from "../../../Buttons/FilterButton/FilterButton";
import OfferStatusPill from "../../../Pills/OfferStatusPill/OfferStatusPill";

export default function OfferStatusFilter({
  column: { filterValue, setFilter, Header },
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [values, setValues] = useState([]);
  const [isNew, setIsNew] = useState(false);
  const [isApproved, setIsApproved] = useState(false);
  const [isRejected, setIsRejected] = useState(false);
  const [isCountered, setIsCountered] = useState(false);
  const [isBounced, setIsBounced] = useState(false);
  const [isNoCap, setIsNoCap] = useState(false);
  const open = Boolean(anchorEl);
  const pid = open ? "offer-status-filter-popover" : undefined;
  const allStatus = ["null", "0", "1", "2", "4", "5", "6", "7"];

  const statuses = [
    {
      id: "null",
      value: isNew
    },
    {
      id: "0",
      value: isApproved
    },
    {
      id: "1",
      value: isRejected
    },
    {
      id: "2",
      value: isCountered
    },
    {
      id: "6",
      value: isBounced
    },
    {
      id: "7",
      value: isNoCap
    },
  ];

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSelected = (event) => {
    const status = event.target.value;
    const value = event.target.checked;
    let updatedValues = values;

    if (value) {
      updatedValues.push(status);
      if (status === "null") updatedValues.push("4");
      if (status === "0") updatedValues.push("5");
    } else {
      if (status === "null") updatedValues = updatedValues.filter(value => value != status && value != "4");
      else if (status === "0") updatedValues = updatedValues.filter(value => value != status && value != "5");
      else updatedValues = updatedValues.filter(value => value != status);
    }
    setValues(updatedValues);

    switch (status) {
      case "null":
      case "4":
        setIsNew(value);
        break;
      case "0":
      case "5":
        setIsApproved(value);
        break;
      case "1":
        setIsRejected(value);
        break;
      case "2":
        setIsCountered(value);
        break;
      case "6":
        setIsBounced(value);
        break;
      case "7":
        setIsNoCap(value);
        break;
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEnter = () => {
    setFilter(values.join().toUpperCase());
    handleClose();
  };

  const handleClear = () => {
    handleDeselectAll();
    setFilter(undefined);
    handleClose();
  };

  const handleSelectAll = () => {
    setIsNew(true);
    setIsApproved(true);
    setIsRejected(true);
    setIsCountered(true);
    setIsBounced(true);
    setIsNoCap(true);
    setValues(allStatus);
  };

  const handleDeselectAll = () => {
    setIsNew(false);
    setIsApproved(false);
    setIsRejected(false);
    setIsCountered(false);
    setIsBounced(false);
    setIsNoCap(false);
    setValues([]);
  };

  useEffect(() => {
    if (!filterValue) {
      handleClear();
    }
  }, [filterValue]);

  return (
    <>
      <FilterButton
        filterValue={filterValue}
        onClick={handleOpen}
      />
      <StyledPopover
        id={pid}
        open={open}
        anchorEl={anchorEl}
        titleObject={
          <span style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }} >
            <Typography variant="subhead1">Sort by {Header}</Typography>
          </span>}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-evenly", color: "primary.60", textDecoration: "underline", cursor: "pointer" }}>
          <Typography onClick={handleSelectAll}>Select All</Typography>
          <Typography onClick={handleDeselectAll}>Deselect All</Typography>
        </Box>
        <Box sx={{
          margin: "20px 0 25px 0",
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)"
        }}>
          <FormGroup sx={{ marginTop: "20px", height: "170px", width: "120px" }}>
            {statuses.map((status) => (
              <FormControlLabel
                key={`checkbox-${status.id}`}
                control={
                  <Box sx={{ margin: "8px" }}>
                    <PrimaryCheckbox
                      checked={status.value}
                      handleChange={handleSelected}
                      value={status.id}
                      color="black_solid.60"
                    />
                  </Box>
                }
                label={
                  <OfferStatusPill value={status.id} />
                }
              />
            ))}
          </FormGroup>
        </Box>
        <Box sx={{ display: "flex" }}>
          {filterValue &&
            <SecondaryButton
              label="Clear"
              onClick={handleClear}
            />
          }
          <Box sx={{ margin: "0 20px 0 auto" }}>
            <SecondaryButton
              label="Cancel"
              onClick={handleClose}
            />
          </Box>
          <PrimaryButton
            label="Go"
            onClick={handleEnter}
            width="50px"
          />
        </Box>
      </StyledPopover>
    </>
  );
}

OfferStatusFilter.propTypes = {
  column: PropTypes.object.isRequired
};